export const apiName: string = 'enderecos';
export const TipoLogradouros = [
  "Aeroporto",
  "Alameda",
  "Apartamento",
  "Avenida",
  "Beco",
  "Bloco",
  "Caminho",
  "Escadinha",
  "Estação",
  "Estrada",
  "Fazenda",
  "Fortaleza",
  "Galeria",
  "Ladeira",
  "Largo",
  "Parque",
  "Praça",
  "Praia",
  "Quadra",
  "Quilômetro",
  "Quinta",
  "Rodovia",
  "Rua",
  "Super quadra",
  "Travessa",
  "Viaduto",
  "Vila"
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/enderecos/shared/data.service.ts
 **/